import { render, staticRenderFns } from "./ImageEdit.vue?vue&type=template&id=88382bb2&"
import script from "./ImageEdit.vue?vue&type=script&lang=js&"
export * from "./ImageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports